import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { makeQueryClient } from '@/lib/queryClient'
import { Providers } from '@/app/Providers'
import { makeRouter } from '@/router'
import { initTheme } from '@/lib/theme'
import { getLang } from '@/i18n'
import './styles.css'

initTheme()
document.documentElement.lang = getLang()

const queryClient = makeQueryClient()
const router = makeRouter(queryClient)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers queryClient={queryClient}>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
)
